module.exports = __webpack_public_path__ + "static/logo-mariott-a892ac82235aedf46ab09e7eb52214e5.png";